import { z } from 'zod'

/**
 * Zod speaks French in this app (#1526, root `AGENTS.md` golden rule 6).
 *
 * Every schema states its own French message for the rules it declares, but
 * zod's BUILT-IN messages — the ones raised before any custom check runs — were
 * still English: editing a technician's SIRET while its stored SIREN was NULL
 * printed « Invalid input: expected string, received null » under the SIREN
 * field. Registering the locale once fixes the whole app rather than the one
 * field that was noticed; custom messages are untouched, the locale only fills
 * in what a schema did not word itself.
 *
 * Imported for its side effect from `main.tsx` — and from any test that asserts
 * on a built-in message, since tests never load the entry point.
 */
z.config(z.locales.fr())
